import VueRouter from "vue-router";
import Landing from "./components/Landing";
import Vue from "vue";
import About from "./components/About";
import Career from "./components/Career";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import TermsConditionsReferral from "./components/TermsConditionsReferral";
import PaymentSuccess from "./components/PaymentSuccess.vue";
import PaymentCancel from "./components/PaymentCancel.vue";
import SupportUs from "./components/SupportUs.vue";
import LandingClean from "./components/LandingClean.vue";
import ShowpieceLanding from "./components/ShowpieceLanding.vue";
import AboutNew from "./components/AboutNew.vue";
import PrivacyPolicyNew from "./components/PrivacyPolicyNew.vue";
import TermsOfServiceNew from "./components/TermsOfServiceNew.vue";
import SupportUsNew from "./components/SupportUsNew.vue";
import CareerNew from "./components/CareerNew.vue";
import PaymentSuccessNew from "./components/PaymentSuccessNew.vue";
import PaymentCancelNew from "./components/PaymentCancelNew.vue";
// import Calculator from "./components/Calculator.vue";

Vue.use(VueRouter);

// Navigating to the route that's already active (e.g. clicking a nav link
// for the current page) rejects with NavigationDuplicated by default.
// Swallow that specific case instead of letting it surface as a console error.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
            return err;
        }
        throw err;
    });
};

const routes = [
    { path: "/", name: 'home', component: ShowpieceLanding },
    { path: "/home-v1", name: 'homeV1', component: Landing },
    { path: "/about", name: 'about', component: AboutNew },
    { path: "/about-v1", name: 'aboutV1', component: About },
    { path: "/career", name: 'career', component: CareerNew },
    { path: "/career-v1", name: 'careerV1', component: Career },
    { path: "/ilovetcb", name: 'supportUs', component: SupportUsNew },
    { path: "/ilovetcb-v1", name: 'supportUsV1', component: SupportUs },
    { path: "/payment-success", name: 'paymentSuccess', component: PaymentSuccessNew },
    { path: "/payment-success-v1", name: 'paymentSuccessV1', component: PaymentSuccess },
    { path: "/payment-cancel", name: 'paymentCancel', component: PaymentCancelNew },
    { path: "/payment-cancel-v1", name: 'paymentCancelV1', component: PaymentCancel },
    { path: "/privacy-policy", name: 'privacyPolicy', component: PrivacyPolicyNew },
    { path: "/privacy-policy-v1", name: 'privacyPolicyV1', component: PrivacyPolicy },
    { path: "/terms-of-service", name: 'termsOfService', component: TermsOfServiceNew },
    { path: "/terms-of-service-v1", name: 'termsOfServiceV1', component: TermsOfService },
    { path: "/terms-conditions-referral", name: 'termsConditionsReferral', component: TermsConditionsReferral },
    { path: "/new", name: 'landingClean', component: LandingClean },
    { path: "/new-design", name: 'newDesign', component: ShowpieceLanding },
    // { path: "/calc", name: 'calculator', component: Calculator },
];

const router = new VueRouter({
    // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
